<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getCustomAttrList_data.csAttrLabel"
          placeholder="请输入客户属性名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getCustomAttrList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addCustomAttr"
          @click="$form('addCustomAttr')"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加客户属性
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getCustomAttrList'
      api='getCustomAttrList'
      xupdateapi='updateCustomAttr'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addCustomAttr:    [ "新增客户属性信息", "el-icon-circle-plus" ],
        updateCustomAttr: [ "修改客户属性信息", "el-icon-edit-outline"],
        $succeed$: getCustomAttrList
      }'
      @opened='$form("addCustomAttr","ifshow") && (Myformdata.csAttrType=1)'
      @close='$form("addCustomAttr","reset")' >
      <hide slot='csAttrId' />
      <template v-slot:csAttrType="{Myformdata}" >
         <el-radio v-model="Myformdata.csAttrType" :label="csAttrKeyOne">字符</el-radio>
         <el-radio v-model="Myformdata.csAttrType" :label="csAttrKeyTwo">数字</el-radio>
  	  </template>
      <template v-slot:csAttrSize="{Myformdata}" >
         <el-input v-model="Myformdata.csAttrSize" type="number" placeholder="请输入数据长度"></el-input>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      csAttrId: null,
      csAttrKeyOne:1,
      csAttrKeyTwo:2,

      tableColums_getCustomAttrList: {
        $selection: false,

        csAttrKey: '属性key',

        csAttrLabel: '属性名称',

        csAttrType: ['数据格式',,'@v-if: 1:字符, 2:数字 '],

        csAttrSize: '数据长度',
        // csAttrSize: ['数据长度',,'@v-if: 0:不限 '],

        csAttrOrder: '排序',

        ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],

        $operation: [
          '操作', 200,
          this.updateCustomAttr && `@text: 编辑#success
           @click: $form("updateCustomAttr",$row)
          `,
          this.deleteCustomAttr && `@text: 删除#danger
           @click: _confirm('确定要删除该客户属性吗?')
                   .trigger('deleteCustomAttr',{csAttrId:$row.csAttrId})
                   .trigger('getCustomAttrList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getCustomAttrList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/help/CustomAttr.vue